/**
 * 이미지 블록 (P5-②) — BlockNote `image` 블록 렌더/직렬화.
 * 블록 JSON: { type:"image", props:{ url, caption?, previewWidth?, name?, textAlignment?, showPreview? }, content:[], children:[] }
 * props는 verbatim 보존(__props) → 라운드트립. 리사이즈는 ./controls.js(attachImageControls)가 previewWidth 갱신.
 *  - textAlignment(A6): 이미지 블록 정렬(left/center/right)
 *  - showPreview(A6): false면 썸네일 대신 파일명 카드만 표시
 *  - name(A6): 파일명(미리보기 끔 카드·alt 대체)
 */

import { neutralizeUrl } from "../../utils/url.js";

export function imageBlockToElement(block) {
  if (typeof document === "undefined") throw new Error("imageBlockToElement: DOM 필요");
  const el = document.createElement("div");
  el.className = "block";
  el.dataset.type = "image";
  if (block && block.id != null) el.dataset.id = String(block.id);
  el.__props = block && block.props ? { ...block.props } : {};
  el.__children = block && Array.isArray(block.children) ? block.children : [];

  const props = el.__props;
  const wrap = document.createElement("div");
  wrap.className = "lumir-image";
  wrap.setAttribute("contenteditable", "false");
  if (props.textAlignment && props.textAlignment !== "left") wrap.dataset.align = props.textAlignment; // A6 정렬

  const showPreview = props.showPreview !== false; // 기본 true

  if (props.url && showPreview) {
    const inner = document.createElement("div");
    inner.className = "lumir-image-inner";
    if (props.previewWidth) inner.style.width = props.previewWidth + "px";
    const img = document.createElement("img");
    img.src = neutralizeUrl(props.url);
    img.alt = props.caption || props.name || "";
    img.draggable = false;
    inner.appendChild(img);
    inner.insertAdjacentHTML("beforeend", '<div class="lumir-image-handle left"></div><div class="lumir-image-handle right"></div>');
    wrap.appendChild(inner);
    if (props.caption) {
      const cap = document.createElement("div");
      cap.className = "lumir-image-caption";
      cap.textContent = props.caption;
      wrap.appendChild(cap);
    }
  } else if (props.url && !showPreview) {
    // A6: 미리보기 끔 → 파일명 카드(클릭 시 원본 링크)
    const card = document.createElement("a");
    card.className = "lumir-image-namecard";
    card.href = neutralizeUrl(props.url);
    card.target = "_blank";
    card.rel = "noopener noreferrer";
    card.textContent = props.name || props.caption || props.url;
    wrap.appendChild(card);
  } else {
    const ph = document.createElement("div");
    ph.className = "lumir-image-placeholder";
    ph.textContent = "이미지 URL 없음";
    wrap.appendChild(ph);
  }
  el.appendChild(wrap);
  return el;
}

export function imageElementToBlock(el) {
  const block = {};
  if (el.dataset.id != null) block.id = el.dataset.id;
  block.type = "image";
  block.props = el.__props || {};
  // 파일형 블록(image/video/audio/file)은 blocknote 구조상 content 키가 없다(no content).
  block.children = el.__children || [];
  return block;
}
